import React from "react";
import { Card, Space, Typography } from "antd";
import THEME from "../theme";

const { Text } = Typography;

const StyledCard = ({ children, title, icon, extra, style, ...props }) => (
  <Card
    title={
      title && (
        <Space>
          {icon}
          <Text strong style={{ fontSize: 16, color: THEME.primary }}>
            {title}
          </Text>
        </Space>
      )
    }
    extra={extra}
    style={{
      boxShadow: THEME.cardShadow,
      border: "none",
      ...style,
      background: THEME.light,
      borderBottom: `2px solid ${THEME.primary}`,
      borderRadius: `${THEME.borderRadius} ${THEME.borderRadius} 0 0`,
    }}
    {...props}
  >
    {children}
  </Card>
);

export default StyledCard;
